<template>
  <div>
    <v-row>
      <v-col cols="12">
        <span class="d-flex justify-center headline primary--text font-weight-bold"> Finalizado </span>
      </v-col>
      <v-col cols="12" class="pt-0">
        <span class="d-flex justify-center title pt-0" color="primary"> O que você deseja fazer? </span>
      </v-col>
      <v-col cols="12" class="pt-1 d-flex justify-center">
        <v-img :src="require('assets/imgs/boneco_confirmacao.svg')" width="141" height="130" contain />
      </v-col>
      <v-col cols="12" class="mt-auto pa-0 pb-3">
        <v-btn class="mt-4 pa-5" :large="$vuetify.breakpoint.mdAndDown" color="primary" @click="selecionar('salvar')" block outlined data-cy="salvarSimulacao">Salvar Simulação</v-btn>
        <v-btn class="mt-4 pa-5" :large="$vuetify.breakpoint.mdAndDown" color="primary" @click="selecionar('enviar')" block outlined data-cy="enviarSimulacao">Salvar e Enviar</v-btn>
        <v-btn class="mt-4 pa-5" :large="$vuetify.breakpoint.mdAndDown" color="primary" @click="selecionar('encerrar')" block outlined data-cy="encerrarSimulacao">Encerrar Simulação</v-btn>
        <v-btn class="mt-5 pa-5" :large="$vuetify.breakpoint.mdAndDown" color="primary" @click="selecionar('prosseguir')" block data-cy="prosseguirProposta">Prosseguir para Proposta</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  methods: {
    selecionar (opcao) {
      this.$emit('nextStep', opcao)
    }
  },
}
</script>
